import React, { useState, useEffect } from 'react';
import TransactionListComponents from '../components/TransactionListComponents';
import TransactionForm from '../components/TransactionForm';
import { useUser } from '../contexts/UserContext';

const TransactionList = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [apps, setApps] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const { user } = useUser();

  // Fetch apps and transactions
  const fetchData = async () => {
    try {
      if (!user?.id) return; // Don't fetch if there's no user


      // Fetch apps
      const appsResponse = await fetch(`${API_BASE_URL}apps/${user.id}`);
      const appsData = await appsResponse.json();
      setApps(appsData);

      if (user?.id) {
        // Fetch transactions with userId in the URL
        const transactionsResponse = await fetch(`${API_BASE_URL}transactions/${user.id}`);
        const transactionsData = await transactionsResponse.json();
        setTransactions(transactionsData);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [user]);
  
  const handleNewTransaction = async (transactionData) => {
    try {
      // Add userId to transaction data
      const enrichedTransactionData = {
        ...transactionData,
        userId: user.id
      };

      const response = await fetch(`${API_BASE_URL}transactions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(enrichedTransactionData),
      });
      const newTransaction = await response.json();

      // Find corresponding app and add its details
      const appId = apps.find((app) => app._id === newTransaction.appId);
      const transactionWithApp = { ...newTransaction, appId };

      setTransactions([transactionWithApp, ...transactions]);
    } catch (error) {
      console.error('Error creating transaction:', error);
    }
  };

  const handleUpdateTransaction = async (updatedTransactions) => {
    try {
      console.log('updatedTransactions', updatedTransactions);
      const response = await fetch(`${API_BASE_URL}transactions/updateTransactions`, {
        method: "PATCH",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedTransactions),
      });
      await response.json();
      fetchData();
    } catch (error) {
      console.error('Error updating transactions:', error);
    }
  };

  const handleDeleteTransaction = async (transactionId) => {
    try {
      await fetch(`${API_BASE_URL}transactions/${transactionId}`, {
        method: "DELETE",
      });
      setTransactions(transactions.filter((transaction) => transaction._id !== transactionId));
    } catch (error) {
      console.error("Error deleting transaction:", error);
    }
  };

  return (
    <div className="p-6" style={{ backgroundColor: '#C6D2ED', minHeight: '100vh' }}>
      <div className="mb-6">
        <TransactionForm 
          apps={apps} 
          onSubmit={handleNewTransaction} 
        />
      </div>
      <div>
        <TransactionListComponents 
          transactions={transactions} 
          apps={apps} 
          onUpdateTransaction={handleUpdateTransaction}
          onDeleteTransaction={handleDeleteTransaction}
        />   
      </div>
    </div>
  );
};

export default TransactionList;